import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { Subscription } from 'rxjs';
import {
  ConstructionType,
  getConstructionTypeEnumLabel,
} from 'src/app/_enums/construction/construction-type.enum';
import {
  EntityType,
  getEntityTypeLabel,
} from 'src/app/_enums/construction/entity-type.enum';
import {
  getNearestStructureDistanceEnumLabel,
  NearestStructureDistance,
} from 'src/app/_enums/construction/nearest-structure-distance.enum';
import {
  getProjectOwnerTypeLabel,
  ProjectOwnerType,
} from 'src/app/_enums/construction/project-owner-type.enum';
import {
  getTopographyEnumLabel,
  Topography,
} from 'src/app/_enums/construction/topography.enum';
import { InsuranceType } from 'src/app/_enums/insurance-type.enum';
import { FamilyMember } from 'src/app/_types/auth.types';

import { LeadFormBase } from '../lead-form-base';

@Component({
  selector: 'app-lead-construction-form',
  templateUrl: './construction-form.component.html',
  styleUrls: ['./construction-form.component.css'],
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
})
export class ConstructionFormComponent
  extends LeadFormBase
  implements OnDestroy, OnInit
{
  @Input()
  formGroup!: FormGroup;

  @Input()
  familyMembers!: FamilyMember[];

  constructionTypeSubscription!: Subscription;

  constructor(private fb: FormBuilder) {
    super();
  }

  metadataFormGroup: FormGroup = this.fb.group({
    type: InsuranceType.CONSTRUCTION,
    entityType: this.fb.control(null),
    constructionType: this.fb.control(null),
    constructionTypeInfo: this.fb.control(null),
    cadastralNumber: this.fb.control(null),
    postalCode: this.fb.control(null),
    address: this.fb.control(null),
    constructionStartDate: this.fb.control(null),
    constructionEndDate: this.fb.control(null),
    insuranceStartDate: this.fb.control(null),
    gradualConstruction: this.fb.control(null),
    constructionStarted: this.fb.control(null),
    architect: this.fb.group({
      fullName: [''],
      email: [''],
      phoneNumber: [''],
      address: [''],
    }),
    civilEngineer: this.fb.group({
      fullName: [''],
      email: [''],
      phoneNumber: [''],
      address: [''],
    }),
    projectOwner: this.fb.group({
      fullName: [''],
      email: [''],
      phoneNumber: [''],
      address: [''],
      type: [null],
    }),
    constructionWorkInsuranceWanted: this.fb.control(null),
    fireNaturalDisasterInsurance: this.fb.control(null),
    projectOwnerCivilResponsibility: this.fb.control(null),
    ownerWithoutInsurance: this.fb.control(null),
    nearAdjuvant: this.fb.control(null),
    totalCost: this.fb.control(null),
    isCivilEngineering: this.fb.control(null),
    nearestStructure: this.fb.control(null),
    plannedDemolition: this.fb.control(null),
    topography: this.fb.control(null),
  });

  override ngOnInit(): void {
    super.ngOnInit();
    this.formGroup.removeControl('metadata');
    if (this.metadata) this.metadataFormGroup.patchValue(this.metadata);
    this.formGroup.addControl('metadata', this.metadataFormGroup);

    this.constructionTypeSubscription = this.metadataFormGroup.controls[
      'constructionType'
    ].valueChanges.subscribe((value) => {
      if (value !== ConstructionType.OTHER) {
        this.metadataFormGroup.controls['constructionTypeInfo'].reset();
      }
    });
  }

  entityTypeValues = Object.values(EntityType);

  getEntityTypeLabel = getEntityTypeLabel;

  ConstructionType = ConstructionType;

  constructionTypeValues = Object.values(ConstructionType);

  getConstructionTypeLabel = getConstructionTypeEnumLabel;

  nearestStructureDistanceValues = Object.values(NearestStructureDistance);

  getNearestStructureDistanceLabel = getNearestStructureDistanceEnumLabel;

  topographyValues = Object.values(Topography);

  getTopographyLabel = getTopographyEnumLabel;

  projectOwnerTypes = Object.values(ProjectOwnerType);

  getProjectOwnerTypeLabel = getProjectOwnerTypeLabel;

  ngOnDestroy(): void {
    this.constructionTypeSubscription.unsubscribe();
  }
}
